// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';
 
const msid = '255fe9af-d0fc-4108-8e7a-46e62de3f5f7'; //replace the value between quotes with your site msid value
 
/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */
 
const biGroupsLoggers = {
    // src: biLoggerFactory(group, src, { msid }),
    110: biLoggerFactory('collaboration-page', 110, { msid }),
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
